// Sample engine flow
const engineFlowTemplate = [
  {
    id: '6b2a7e9.7d4498',
    type: 'tab',
    label: 'Transcription Engine Template',
    disabled: false,
    info: ''
  },
  {
    id: 'ce57595.0eb2ba8',
    type: 'event in',
    z: '6b2a7e9.7d4498',
    name: 'V2F Input',
    app: 'system',
    event_type: '',
    event_name: '',
    x: 93.5,
    y: 227,
    wires: [['d2d49ad3.9f0fe8']]
  },
  {
    id: 'd2d49ad3.9f0fe8',
    type: 'function',
    z: '6b2a7e9.7d4498',
    name: '',
    func: `/*This is a template for the Business Logic for creating a Cognitive Engine */\n\n//1. 
        Get the Primary media asset from Veritone\n\n\n\n//2. Pass in your 3rd Party API Token here:
        \nmsg.apiToken = '<API Token>';\n//3. create your API Header details\nmsg.headers = 
        {'Content-Type':'application/json','Authorization':'Bearer' + msg.apiToken};
        \nmsg.url = '<3rd party API uri>';\n\n\nreturn msg;`,
    outputs: 1,
    noerr: 0,
    x: 251.5,
    y: 227,
    wires: [['2096afb8.9b434']]
  },
  {
    id: '2096afb8.9b434',
    type: 'http request',
    z: '6b2a7e9.7d4498',
    name: 'Call 3rd Party API (transcription)',
    method: 'POST',
    ret: 'txt',
    url: '',
    tls: '',
    x: 473.5,
    y: 227,
    wires: [['a0c6261e.6a7d58']]
  },
  {
    id: '2db9ef6.d92801',
    type: 'delay',
    z: '6b2a7e9.7d4498',
    name: 'Poll the API for Response (20s)',
    pauseType: 'delay',
    timeout: '20',
    timeoutUnits: 'seconds',
    rate: '1',
    nbRateUnits: '1',
    rateUnits: 'second',
    randomFirst: '1',
    randomLast: '5',
    randomUnits: 'seconds',
    drop: false,
    x: 1057.5,
    y: 196,
    wires: [['328c8b79.ea1674']]
  },
  {
    id: 'a0c6261e.6a7d58',
    type: 'switch',
    z: '6b2a7e9.7d4498',
    name: 'API Response?',
    property: 'payload',
    propertyType: 'msg',
    rules: [
      {
        t: 'eq',
        v: 'running',
        vt: 'str'
      },
      {
        t: 'eq',
        v: 'complete',
        vt: 'str'
      }
    ],
    checkall: 'true',
    repair: false,
    outputs: 2,
    x: 760.5,
    y: 228,
    wires: [
      ['2db9ef6.d92801', 'bab5a2c7.b2ede'],
      ['bab5a2c7.b2ede', '71341ca.92552e4']
    ]
  },
  {
    id: '328c8b79.ea1674',
    type: 'function',
    z: '6b2a7e9.7d4498',
    name: 'Format API Request',
    func: '//Format the API Request to adhere to 3rd Party API\nreturn msg;',
    outputs: 1,
    noerr: 0,
    x: 473.5,
    y: 107,
    wires: [['51ef2e.d634f0d4']]
  },
  {
    id: '51ef2e.d634f0d4',
    type: 'http request',
    z: '6b2a7e9.7d4498',
    name: 'Call 3rd Party API',
    method: 'POST',
    ret: 'txt',
    url: '',
    tls: '',
    x: 709,
    y: 107,
    wires: [['a0c6261e.6a7d58']]
  },
  {
    id: 'bab5a2c7.b2ede',
    type: 'debug',
    z: '6b2a7e9.7d4498',
    name: '',
    active: true,
    tosidebar: true,
    console: false,
    tostatus: false,
    complete: 'false',
    x: 1018.5,
    y: 91,
    wires: []
  },
  {
    id: '86b0b4fb.42a958',
    type: 'aiware',
    z: '6b2a7e9.7d4498',
    name: 'VTN Output Standard',
    format: 'handlebars',
    syntax: 'mustache',
    template:
      '{ jobs(targetId: {{tdoId}}) { records {id status createdDateTime}}}',
    x: 1089.5,
    y: 328,
    wires: [['748cee45.0f8ef'], ['748cee45.0f8ef']]
  },
  {
    id: '71341ca.92552e4',
    type: 'function',
    z: '6b2a7e9.7d4498',
    name: 'Format Response',
    func: '\nreturn msg;',
    outputs: 1,
    noerr: 0,
    x: 858.5,
    y: 327,
    wires: [['86b0b4fb.42a958']]
  },
  {
    id: '748cee45.0f8ef',
    type: 'debug',
    z: '6b2a7e9.7d4498',
    name: '',
    active: true,
    tosidebar: true,
    console: false,
    tostatus: false,
    complete: 'false',
    x: 1286.5,
    y: 251,
    wires: []
  }
];

// from node-red/red/runtime/util.js
function generateId() {
  return (1 + Math.random() * 4294967295).toString(16);
}

function cloneEngineFlow(flow, engineId) {
  const ids = flow.map(f => f.id);
  const newIds = {};
  ids.forEach(id => {
    newIds[id] = generateId();
  });
  return flow.map(f => {
    const newF = { ...f };
    newF.id = newIds[f.id];
    newF.z = newIds[f.z];
    newF.wires = (f.wires || []).map(arr => {
      return (arr || []).map(id => newIds[id]);
    });
    return newF;
  });
}

export function addEngineFlow(currentflow, engineId) {
  const newFlow = cloneEngineFlow(engineFlowTemplate, engineId);
  return [].concat(currentflow).concat(newFlow);
}



// WEBPACK FOOTER //
// ./src/client/modules/engine-builds/workflow.js